
<template >
  <!-- Grafico -->
  <chart :data="chartData" :options="options" v-if="loaded"></chart>
</template>

<script>
import Chart from "./chart/BarChart.js";
import { get_chartMax } from "@/api/api.statistiche.js";

export default {
  components: {
    Chart,
  },

  props: {
    dati: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data: (vm) => ({
    chartData: {
      labels: [],
      datasets: [
        {
          label: "Riepilogo",
          backgroundColor: [],
          data: [],
        },
      ],
    },

    type: "horizontalBar",

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      plugins: {
        datalabels: {
          color: "#000",
          font: { size: "14" },
          anchor: "end",
          align: "end",
        },
      },

      scales: {
        xAxes: [
          {
            ticks: {
              min: 0,
              max: 3000000,
              beginAtZero: true,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              beginAtZero: true,
            },
          },
        ],
      },
    },
    loaded: false,
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.chartData.datasets[0].data = [];
      this.chartData.labels = [];

      // NOTA: The most common problem is, that you mount your chart component directly and pass in data from an async API call.
      // The problem with this approach is, that chart.js tries to render your chart and access the chart data,
      // but your API call  is async. So you chart mounts before your data arrives.
      // To prevent this, a simple v-if is the best solution.
      this.loaded = false;

      // Ciclo sui dati
      for (let i = 1; i < this.dati.length; i++) {
        // NOTA: serviva per nascondere quelli senza qtà
        //if (this.dati[i].TotalePorte == 0) continue;

        this.chartData.datasets[0].data.push(this.dati[i].TotalePorte);
        this.chartData.labels.push(this.dati[i].Serie);

        let colore = "";
        if (this.dati[i].Tipologia == "MPM PORTE") colore = "#005055";
        else if (this.dati[i].Tipologia == "MPM ARREDO") colore = "#8CC63F";
        else if (this.dati[i].Tipologia == "MPM SICUREZZA") colore = "#F3A633";
        else if (this.dati[i].Tipologia == "RIEPILOGO 1") colore = "#f2f2f2";
        else if (this.dati[i].Tipologia == "RIEPILOGO 2") colore = "#cde1f4";
        this.chartData.datasets[0].backgroundColor.push(colore);
      }
      this.chartData.datasets[0].borderWidth = 1;
    },

    async calcolaMax() {
      let max = 0;
      this.dati.forEach((d) => {
        if (d != undefined && d.Serie != "Periodo")
          if (Number(d.TotalePorte) > max) max = d.TotalePorte;
      });

      if (this.dati[0] == undefined) return;
      let par = {
        max: max.toString(),
        data: this.dati[0].TotalePorte.toString(),
      };
      let res = await get_chartMax(par);
      this.options.scales.xAxes[0].ticks.max = res.data;
    },
  },

  async mounted() {
    await this.caricaDati();
    await this.calcolaMax();
    this.loaded = true;
  },
};
</script>

